module.exports = {"center":[51,10],"zoom":5}


//////////////////
// WEBPACK FOOTER
// ./src/store/config/defaultMap.json
// module id = Ei+O
// module chunks = 1